import { createStore, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "redux-devtools-extension";
import React from "react";

import rootReducer from "./reducers/root";

const store = createStore(
	rootReducer,
	composeWithDevTools(applyMiddleware(thunk))
);

const DataProvider = ({ children }) => {
	return <Provider store={store}>{children}</Provider>;
};

export default DataProvider;
